import './LegalNotices.scss';

import React from 'react';
import PropTypes from 'prop-types';

import provideTranslations from 'decorators/provideTranslations';

import NavPage from 'components/layout/NavPage';
import Attribution from 'components/terms/legalNotices/Attribution';

@provideTranslations('Core')
class LegalNoticesContainer extends React.Component {
  render() {
    return (
      <LegalNotices {...this.props} />
    );
  }
}

class LegalNotices extends React.Component {
  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  render() {
    const { getString } = this.context;

    return (
      <NavPage>
        <div className="aa-legalNotices-container">
          <h3>{ getString('AA_Legal_Notices_Attribution') }</h3>
          <Attribution />
        </div>
      </NavPage>
    );
  }
}

export default LegalNoticesContainer;
